module.exports = __webpack_public_path__ + "img/logo-dark.fb82af86.png";